var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Dialog, TypographyBody, DialogHeader, DialogContent, DialogFooter, Button, } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
export function ErrorNavlRoomUpdateModal(props) {
    const _a = props, { handleClick } = _a, dialogProps = __rest(_a, ["handleClick"]);
    const { resourceStrings: { NAVL_ROOM_UPDATE_MODAL_HEADING, NAVL_ROOM_UPDATE_MODAL_MESSAGE, OK }, } = useGlobalContext();
    return (React.createElement(Dialog, Object.assign({}, dialogProps, { onClose: handleClick }),
        React.createElement(DialogHeader, { "data-id": "room-unavailable-dialog", withCloseButton: true, border: false },
            React.createElement(TypographyBody, { weight: "bold", "data-id": "room-unavailable-heading" }, NAVL_ROOM_UPDATE_MODAL_HEADING)),
        React.createElement(DialogContent, { pb: 1 }, NAVL_ROOM_UPDATE_MODAL_MESSAGE),
        React.createElement(DialogFooter, { alignSelf: "end", border: false },
            React.createElement(Button, { onClick: handleClick }, OK))));
}
